import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=382813b6&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=ts&"
export * from "./AppMain.vue?vue&type=script&lang=ts&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=382813b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382813b6",
  null
  
)

export default component.exports